export default __webpack_public_path__ + "static/media/transfer_navicon.dfaa6f6b.svg";